function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.333 2H12.9997C13.1765 2 13.3461 2.07024 13.4711 2.19526C13.5961 2.32028 13.6663 2.48985 13.6663 2.66666V13.3333C13.6663 13.5101 13.5961 13.6797 13.4711 13.8047C13.3461 13.9298 13.1765 14 12.9997 14H0.999674C0.822863 14 0.653294 13.9298 0.52827 13.8047C0.403246 13.6797 0.333008 13.5101 0.333008 13.3333V2.66666C0.333008 2.48985 0.403246 2.32028 0.52827 2.19526C0.653294 2.07024 0.822863 2 0.999674 2H3.66634V0.666664H4.99967V2H8.99967V0.666664H10.333V2ZM1.66634 6V12.6667H12.333V6H1.66634ZM2.99967 8.66666H6.33301V11.3333H2.99967V8.66666Z",
  fill: "#333333"
});

var SvgSchedule = function SvgSchedule(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSchedule, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/schedule.d1a63d03.svg";
export { ForwardRef as ReactComponent };